<template>
  <div>
    <div class="agent-custom-info">
      <div class="agent-custom-info-sear">
        <div class="agent-custom-info-input">
          <span>
            <img alt src="@/assets/images/agent/mag_03.png">
          </span>
          <input name="param" placeholder="请输入手机号码，姓名进行查找" type="text" v-model="param.keyword">
        </div>
        <a @click="getCustomerList()" href="javascript:void(0)">
          <div class="sear-but">查找</div>
        </a>
      </div>
      <div v-if="!customers_map">没有符合您要求的内容！</div>
      <div v-else>
        <div :key="index" class v-for="(value,key,index) in customers_map">
          <div class>
            <div :key="item_index+'_'+index" class="custom-info" v-for="(item,item_index) in value">
              <div class="cimg">
                <img :src="item.icon ? item.icon : no_photo" class="head-photo-small">
              </div>
              <div class="custom-info-word">
                <span class="overflow-ellipsis-line1" style="width : 265px">{{item.name}}</span>&nbsp;&nbsp;&nbsp;
                <em>注册会员</em>
                <br>
                <span>
                  性别：
                  <span v-if="!item.sex">无</span>
                  <span v-else>{{item.sex}}</span>
                </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>手机号码：{{item.mobile_phone}}</span>
              </div>
              <div class="custom-msg">
                <a @click="$pushByName('aMsgList',{to:item.member_id})" href="javascript:void(0);">
                  <span>
                    <img alt src="@/assets/images/agent/samessage_03.png">
                  </span>
                  <p>发送消息</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import no_photo from '@/assets/images/html/no_photo.gif'
export default {
  name: 'CustomList',
  componentName: 'CustomList',
  data () {
    return {
      url: 'member/customer_list',
      no_photo: no_photo,
      userinfo: {
        username: this.$sessionStorageUtil.get('agent_username')
      },
      member_list: [],
      param: {
        source: '',
        username: this.$sessionStorageUtil.get('agent_username'),
        user_id: '',
        keyword: '',
      },
      customers_map: {}
    }
  },
  created () {
    this.$myGet('userinfo/by_username/' + this.userinfo.username)
      .then(res => {
        const rcode = res.response.data.rcode
        if (rcode == 0) {
          this.userinfo = res.response.data.userinfo
          this.param.source = this.userinfo.source
          this.param.username = this.userinfo.username
          this.param.user_id = this.userinfo.user_id
          this.getCustomerList()
        } else {
          this.$msg(res.response.data.messages[0].msg, 'error')
        }
      }).catch(err => {
        this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
      })
  },
  methods: {
    getCustomerList () {
      this.$myGet(this.url, this.param)
        .then(res => {
          const rcode = res.response.data.rcode
          if (rcode == 0) {
            this.customers_map = res.response.data.customers_map
            // this.$pushByName('editPhone2')
          } else {
            this.$msg(res.response.data.messages[0].msg, 'error')
          }
        }).catch(err => {
          this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
        })
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/pages/customer/memberInfo.css';
@import '../../assets/css/pages/agent/css.css';
</style>



// WEBPACK FOOTER //
// src/pages/agent/customList.vue